import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './LoginPage.css';
import { useSession } from '../auth/SessionContext';
import { useI18n } from '../i18n';

const BACKEND_URI = process.env.REACT_APP_BACKEND_URI;

function RobotIcon() {
  return (
    <svg
      className="login-icon"
      viewBox="0 0 72 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="72" height="72" rx="16" fill="#f49833" />
      {/* Antenna */}
      <rect x="32" y="6" width="8" height="14" rx="4" fill="#ffffff" opacity="0.9" />
      {/* Head */}
      <rect x="12" y="18" width="48" height="42" rx="10" fill="#f49833" />
      {/* Face plate */}
      <rect x="16" y="22" width="40" height="34" rx="8" fill="#de8125" />
      {/* Left eye */}
      <rect x="20" y="30" width="13" height="10" rx="3" fill="#ffffff" />
      {/* Right eye */}
      <rect x="39" y="30" width="13" height="10" rx="3" fill="#ffffff" />
      {/* Mouth grid */}
      <rect x="20" y="46" width="32" height="6" rx="2" fill="#ffffff" opacity="0.25" />
      <rect x="20" y="46" width="7" height="6" rx="1" fill="#ffffff" opacity="0.6" />
      <rect x="29" y="46" width="6" height="6" rx="1" fill="#ffffff" opacity="0.6" />
      <rect x="37" y="46" width="6" height="6" rx="1" fill="#ffffff" opacity="0.6" />
      <rect x="45" y="46" width="7" height="6" rx="1" fill="#ffffff" opacity="0.6" />
    </svg>
  );
}

function LockIcon() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#f49833"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
      <path d="M7 11V7a5 5 0 0 1 10 0v4" />
    </svg>
  );
}

export default function LoginPage() {
  const navigate = useNavigate();
  const { user, loading } = useSession();
  const { t } = useI18n();

  useEffect(() => {
    if (!loading && user) {
      navigate('/dashboards', { replace: true });
    }
  }, [loading, user, navigate]);

  const handleLogin = () => {
    window.location.href = `${BACKEND_URI}/auth/external/login`;
  };

  if (loading || user) {
    return null;
  }

  return (
    <div className="login-page">
      <div className="login-card">
        <RobotIcon />
        <h1 className="login-title">{t('app.title')}</h1>
        <div className="login-divider" />
        <button className="sso-button" onClick={handleLogin}>
          <LockIcon />
          {t('login.sso')}
        </button>
      </div>
    </div>
  );
}
